import angular from 'angular';
import './ladprovider-list.component.js';

(function() {
  'use strict';

  angular.module('app.ladprovider').config(routesConfig);

  routesConfig.$inject = ['$stateProvider'];

  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.ladprovider', {
        abstract: true,
        component: 'contentLayout'
      })
      .state('app.ladprovider.list', {
        url: '/ladprovider/list',
        views: {
          content: {
            component: 'ladproviderList'
          }
        },
        resolve: {
          ladproviders: [
            'LadProviderService',
            function(LadProviderService) {
              return LadProviderService.findAll();
            }
          ]
        },
        data: {
          authorizedRole: 'ADMIN'
        }
      })
      .state('app.ladprovider.details', {
        url: '/ladprovider/{guid}',
        views: {
          content: {
            component: 'ladproviderDetails'
          }
        },
        params: {
          guid: null
        },
        resolve: {
          ladprovider: [
            '$transition$',
            'LadProviderService',
            function($transition$, LadProviderService) {
              if ($transition$.params().guid) {
                return LadProviderService.get({ ladproviderId: $transition$.params().guid });
              }
            }
          ]
        },
        data: {
          authorizedRole: 'ADMIN'
        }
      });
  }
})();
